import { render } from "./RouletteSkin.vue?vue&type=template&id=2e951360&scoped=true&ts=true"
import script from "./RouletteSkin.vue?vue&type=script&lang=ts"
export * from "./RouletteSkin.vue?vue&type=script&lang=ts"

import "./RouletteSkin.vue?vue&type=style&index=0&id=2e951360&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e951360"]])

export default __exports__